<div class="subBlockContainer" id="apitoken" *ngIf="hasAdminAccess">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="child-body">
      <div class="inner-subBlock-wrapper">
        <!-- <div class="page-title-wrapper">
          <div class="title blade-title-font">
            {{title}}
          </div>
          <i class="material-icons closebutton-pullfloat-right" (click)="close()" >close</i>
        </div> -->
        <p class="page-title-description">Get connected with Dicker Data’s API suite to automate your ordering process.  Below you can generate API access tokens for both the production system as well as our sandbox environment.</p>
        <section>
          <label class="font-x10 text-uppercase margin-b-x15">{{ tokenLable }}</label>
          <input class="apitoken_input" type="text" [value]="currentLiveToken?.token" readonly>
          <button class="button button-red button-mid generate-btn" (click)="generateToken()">Generate</button>
          <p class="padding-t-x16 font-x9 align-right">Last modified: {{currentLiveToken?.modifiedDate}} by {{currentLiveToken?.loginId}}</p>
        </section>
        <section>
          <ng-select class="customDropdwon" [items]="userList" bindValue="out_email" bindLabel="out_login_id"
            placeholder="Select Integration Contact" [clearable]="true" [(ngModel)]="selectedUserEmail"></ng-select>
            <mat-form-field>
              <input matInput [(ngModel)]="selectedUserEmail" placeholder="Integration Contact Email">
            </mat-form-field>
            
        </section>
        <section *ngIf="testURL">
            <span class="padding-t-x16 font-x10">To generate sandbox tokens please visit <a target="_blank" [href]="testURL">{{testURL}}</a></span>
        </section>
        <!-- <section>
          <label class="title-text">Development Token</label>
          <input type="text" [value]="currentLiveToken?.token">
          <button class="button button-red button-mid generate-btn" (click)="generateToken()">Generate</button>
          <p class="helper-text right">Last modified: {{currentLiveToken?.modifiedDate}} by {{currentLiveToken?.loginId}}</p>
        </section> -->
        <!-- <section>
          <label class="title-text" style="font-size: 10px;">How to integrate</label>
          <button class="button button-red button-large" id="downloadBtn">Download documentation</button>
        </section> -->
      </div>
    </div>
    <loading-screen *ngIf="!loadContent" backDropWidth='350' [showBlurTable]="false" (currentLoadingStatus)="onLoading($event)"></loading-screen>
  </div>
  <modal-popup [modalTitle]="modalDetails.title" [modalContent]="modalDetails.content"></modal-popup>
</div>